import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlanContentComponent } from '../plan-content/plan-content.component';

@Component({
  selector: 'app-plan-sidebar',
  standalone: true,
  imports: [PlanContentComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './plan-sidebar.component.html',
  styleUrl: './plan-sidebar.component.css',
})
export class PlanSidebarComponent {}
